<template>
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M40.8734 22.4188L29.5608 17.0753C29.4516 17.0244 29.3324 16.9987 29.2119 17.0001C29.0915 17.0015 28.9729 17.03 28.8649 17.0834C28.7569 17.1369 28.6624 17.214 28.5883 17.309C28.5142 17.4039 28.4624 17.5144 28.4368 17.6321C28.4342 17.6408 27.5292 21.8472 26.1852 26.0404C25.7271 27.4777 25.214 28.8985 24.6781 30.1464L26.1311 30.8323C27.8765 26.7813 29.2588 21.1892 29.779 18.9525L39.6115 23.5908C39.3096 24.9112 38.5355 28.1488 37.4996 31.3813C36.8303 33.4757 36.0466 35.5675 35.2437 37.0816C34.467 38.6437 33.535 39.4117 33.3264 39.3087C32.0872 39.3349 31.2163 38.2074 30.6298 36.7622C30.3832 36.1264 30.1913 35.4707 30.0565 34.8022C29.9448 34.2629 29.9107 33.9243 29.9081 33.9243C29.8942 33.7878 29.8451 33.6574 29.7655 33.5457C29.686 33.434 29.5787 33.3449 29.4543 33.2872L18.1443 27.9464C18.0155 27.8856 17.8728 27.86 17.7309 27.8723C17.5889 27.8845 17.4527 27.9342 17.3362 28.0162C17.2204 28.0989 17.1286 28.211 17.0703 28.3409C17.0121 28.4708 16.9894 28.6138 17.0046 28.7553C17.0116 28.7955 17.1748 30.3698 17.831 32.0166C18.2866 33.1685 19.0589 34.4758 20.3147 35.1364L31.6212 40.486L31.6264 40.4755C32.1169 40.7329 32.6737 40.9005 33.3256 40.9084C34.8938 40.8063 35.749 39.4527 36.6575 37.8321C39.2755 32.8666 41.3002 23.3456 41.3159 23.3107C41.3546 23.1344 41.3322 22.9502 41.2522 22.7884C41.1723 22.6266 41.0396 22.4968 40.876 22.4205L40.8734 22.4188Z"
      fill="#142B6F"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
}

path.a {
  fill: #CDD1DE;
}

.a-active {
}
</style>
